import { Box, Button, Grid,Modal, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableSortLabel, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import defaultImgg from "../../assets/images/defaultImgg.svg";
import { Label } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { parsePhoneNumber } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import { ReactComponent as UploadIcon } from '../../assets/icons/uploadIcon.svg';
import axios from "axios";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import dayjs from 'dayjs';

var constants = require('../../constant');

const Corporate = () => {
    const [cityFilter, setCityFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [accounterror , setAccountError] = useState(false);
    const [phoneError , setPhoneError] = useState(false);
    const [debtError , setDebtError] = useState(false);
    const [vatError , setVatError] = useState(false);
    const [statusError , setStatusError] = useState(false);
    const [rideLimitError , setRideLimitError] = useState(false);
    const [transactionLimitError , setTransactionLimitError] = useState(false);
    const [paymentMethodError , setPaymentMethodError] = useState(false);
    const [countryCode, setCountryCode] = useState('');
    const [rows, setRows] = useState([]);
    const [corpId, setCorpId] = useState(0);
    const [corpName, setCorpName] = useState('');
    const [monthlyRideLimit, setMonthlyRideLimit] = useState('');
    const [monthlyTransactionLimit, setMonthlyTransactionLimit] = useState('');
    const [corpStatus, setCorpStatus] = useState('Active');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [originalEmail, setOriginalEmail] = useState('');
    const [vatNumber, setVatNumber] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [rePasswordError, setRePasswordError] = useState(false);
    const [rePassword, setRePassword] = useState('');
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [passwordMismatchError, setPasswordMismatchError] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const fileInputRef = useRef(null);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [alternativeEmail, setAlternativeEmail] = useState('');
    const [alternativeEmailError, setAlternativeEmailError] = useState(false);
    const [invoiceDate, setInvoiceDate] = useState('');        // 'YYYY-MM-DD'
    const [invoiceDateError, setInvoiceDateError] = useState(false);
    const [billingAddress, setBillingAddress] = useState('');
    const [billingAddressError, setBillingAddressError] = useState(false);
    const [invoiceData, setInvoiceData] = useState([]);
    const [invoiceCorpId, setInvoiceCorpId] = useState(null);
    const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
    const [invoiceCorpName, setInvoiceCorpName] = useState('');
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [downloadingInvoice, setDownloadingInvoice] = useState(false);
    const [pdfBlobUrl, setPdfBlobUrl] = useState('');
const [pdfLoading, setPdfLoading] = useState(false);
const [pdfError, setPdfError] = useState(false);

useEffect(() => {
    let objectUrl = '';
    let cancelled = false;

    const loadPdf = async () => {
        if (!selectedInvoice?.invoice_url) { setPdfBlobUrl(''); return; }
        setPdfLoading(true);
        setPdfError(false);
        try {
            const res = await fetch(selectedInvoice.invoice_url);
            if (!res.ok) throw new Error('fetch failed');
            const raw = await res.blob();
            const pdfBlob = new Blob([raw], { type: 'application/pdf' });
            objectUrl = URL.createObjectURL(pdfBlob);
            if (!cancelled) setPdfBlobUrl(objectUrl);
        } catch (e) {
            console.error('PDF load failed', e);
            if (!cancelled) { setPdfBlobUrl(''); setPdfError(true); }
        } finally {
            if (!cancelled) setPdfLoading(false);
        }
    };

    loadPdf();
    return () => {
        cancelled = true;
        if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
}, [selectedInvoice]);
    console.log(corpName,"corpname")
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);
    };

    const handleOpenAddCorporate = () => {
        setOpen(true);
        setEditable(false);
        setCorpName('');
        setMonthlyRideLimit('');
        setMonthlyTransactionLimit('');

        setCorpStatus(1);
        setCorpId(0);
        setPhoneNumber('');
        setEmail('');
        setOriginalEmail('');
        setVatNumber('');
        setPassword('');
        setRePassword('');
        setEmailError(false);
        setNameError(false);
        setAccountError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);
        setAlternativeEmail('');
        setInvoiceDate('');
        setBillingAddress('');
        setAlternativeEmailError(false);
        setInvoiceDateError(false);
        setBillingAddressError(false);
    }

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };

    const handleOpenEditCorporate = (row) => {
        setCorpName(row.name);
        setMonthlyRideLimit(row.monthly_ride_limit);
        setMonthlyTransactionLimit(row.monthly_transaction_limit);
        setCorpStatus(row.status);
        setCorpId(row.id);
        setOpen(true);
        setEditable(true);
        setPhoneNumber(row.phone_number);
        setEmail(row.email || '');
        setOriginalEmail(row.email || '');
        setVatNumber(row.vat_number);
        setEmailError(false);
        setNameError(false);
        setAccountError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);
        setAlternativeEmail(row.alternative_email ?? '');
        setInvoiceDate(row.invoice_date ? Number(row.invoice_date) : '');
        setBillingAddress(row.billing_address ?? '');
        setAlternativeEmailError(false);
        setInvoiceDateError(false);
        setBillingAddressError(false);
    }

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
        setOriginalEmail('');
    }

    const fetchCorporateData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/corporates/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchCorporateData();
    },[])

    const handleFileChange = (type) => async(event) => {
            const file = event.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('image', file);
        
                try {
                    const response = await axios.post(operationsUrl + '/upload_image', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    });
        
                    const s3Url = response.data.url;
                    const newImage = {
                        name: file.name,
                        src: s3Url,
                        isUploaded: true,
                    };
        
                    // setBrandLogo(s3Url);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            }
        };

    const handleReset = () => {
        setCorpName('');
        setMonthlyRideLimit('');
        setMonthlyTransactionLimit('');
        setCorpStatus('');
        setCorpId(0);
        setPhoneNumber('');
        setEmail('');
        setOriginalEmail('');
        setVatNumber('');
        setEmailError(false);
        setNameError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);
        setPassword('');
        setRePassword('');
        setPasswordError(false);
        setRePasswordError(false);
        setPasswordMismatchError(false);
        setAlternativeEmail('');
        setInvoiceDate('');
        setBillingAddress('');
        setAlternativeEmailError(false);
        setInvoiceDateError(false);
        setBillingAddressError(false);
    }

    const handleViewUsers = (row) => {
        // navigate(`/corporate/users?corporate_id=${row.id}`);
        navigate(`/corporate/users`,{
            state: {
                corporate_id: row.id
            }
        });
    }

const handleInvoiceofCorporateclient = async (row) => {
    try {
        const token = localStorage.getItem('token');
        const url = serverUrl + '/admin/invoices';
        const response = await makeGetRequestToUrl(url, { token, corporate_id: row.id });

        if (response.flag === 102) {
            localStorage.removeItem('token');
            setErrorMessage('Your session has expired. Please log in again.');
            setTokenExpired(true);
            setTimeout(() => navigate('/signup'), 2000);
            return;
        }

        // This endpoint returns { message, data } with no flag
        const isSuccess = response.flag === 200 || Array.isArray(response.data);

        if (isSuccess) {
            const list = response.data || [];
            setInvoiceData(list);
            setInvoiceCorpName(row.name);
            setSelectedInvoice(list[0] || null);
            setInvoiceModalOpen(true);
        } else {
            setMessage(response.message || 'Failed to fetch invoices');
            showSnackbar(true);
        }
    } catch (error) {
        console.error('Error fetching invoices:', error);
        setMessage('Something went wrong while fetching invoices');
        showSnackbar(true);
    }
};

    const handleCloseInvoiceModal = () => {
        setInvoiceModalOpen(false);
        setSelectedInvoice(null);
        setInvoiceData([]);
    };

    // S3 URL has no extension and is cross-origin, so fetch → blob to force a real download
    const handleDownloadInvoice = async (invoice) => {
        if (!invoice?.invoice_url) return;
        setDownloadingInvoice(true);
        try {
            const res = await fetch(invoice.invoice_url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = `${invoice.invoice_number || 'invoice'}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            // CORS or network issue — fall back to opening in a new tab
            window.open(invoice.invoice_url, '_blank', 'noopener');
        } finally {
            setDownloadingInvoice(false);
        }
    };


    const validatePasswords = () => {
        let valid = true;
    
        if (!password) {
            setPasswordError(true);
            valid = false;
        }
    
        if (!rePassword) {
            setRePasswordError(true);
            valid = false;
        }
    
        if (password && rePassword && password !== rePassword) {
            setPasswordMismatchError(true);
            valid = false;
        } else {
            setPasswordMismatchError(false);
        }
    
        return valid;
    };

    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            name: corpName,
            // monthly_ride_limit: monthlyRideLimit,
            // monthly_transaction_limit: monthlyTransactionLimit,
            // status: corpStatus,
            phone_number: phoneNumber,
            vat_number: vatNumber,
            invoice_date: Number(invoiceDate),
            billing_address: billingAddress,
          };

        if (editable) {
            if ((email || '').trim() !== (originalEmail || '').trim()) {
                payload.email = email;
            }
        } else {
            payload.email = email;
        }

        if(alternativeEmail){
            payload.alternative_email = alternativeEmail;
        }
          
        if(editable && corpId!=0){
            payload.corporate_id = corpId;
        }
        else{
            payload.status = 1
        }

        if(!editable && password){
            payload.manager_password = password;
        }

        if (email && !validateEmail(email)) {
            setEmailError(true);
            setMessage('Please enter a valid email address');
            showSnackbar(true);
            return;
        }

        if(corpName == ""){
            setNameError(true);
            setMessage('Please enter a valid name');
            showSnackbar(true);
            return;
        }

        if(phoneNumber == ""){
            setPhoneError(true);
            setMessage('Please enter a valid phone number');
            showSnackbar(true);
            return;
        }

        if (!editable && !password) {
            setPasswordError(true);
            setMessage('Please enter a valid password');
            showSnackbar(true);
            return;
        }
    
        if (!editable && !rePassword) {
            setRePasswordError(true);
            setMessage('Please re-enter your password');
            showSnackbar(true);
            return;
        }
    
        if (!editable && password !== rePassword) {
            setPasswordMismatchError(true);
            setMessage('Passwords do not match');
            showSnackbar(true);
            return;
        }

        if(vatNumber == ""){
            setVatError(true);
            setMessage('Please enter a valid vat number');
            showSnackbar(true);
            return;
        }


        if (editable && corpStatus === "") {
            setStatusError(true);
            setMessage('Please enter a valid status');
            showSnackbar(true);
            return;
        }
        

        if (alternativeEmail && !validateEmail(alternativeEmail)) {
            setAlternativeEmailError(true);
            setMessage('Please enter a valid alternative email address');
            showSnackbar(true);
            return;
        }

        if (alternativeEmail && email && alternativeEmail.toLowerCase() === email.toLowerCase()) {
            setAlternativeEmailError(true);
            setMessage('Alternative email must differ from the primary email');
            showSnackbar(true);
            return;
        }

        if (invoiceDate == "") {
            setInvoiceDateError(true);
            setMessage('Please select an invoice date');
            showSnackbar(true);
            return;
        }

        if (billingAddress.trim() == "") {
            setBillingAddressError(true);
            setMessage('Please enter a billing address');
            showSnackbar(true);
            return;
        }

        try {
            const url = operationsUrl + '/corporates/add_update_corporates';
            const response = await makePostRequestToUrl(url,payload);
            console.log('response form api', response)
            if (response.flag === 200) {
                console.log('response', response)
                setMessage(response.message)
                showSnackbar(true);
                handleClose(); // Close the modal after saving
                fetchCorporateData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleApproveReject = async(status, id) => {
        console.log('heer')
        const token = localStorage.getItem('token');
        const payload = {
            corporate_id: id,
            status: status,
            token: token
        }
        try {
            const url = operationsUrl + '/corporates/approve_reject_corporate';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchCorporateData();
            } else {
                setMessage(response|| response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    } 

    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    return(
        <>
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Corporate
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '2%', marginBottom: '2%' }}>

                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)} displayEmpty
                        style={{width: '220px', height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Status</MenuItem>
                        <MenuItem value="0">Pending</MenuItem>
                        <MenuItem value="1">Approved</MenuItem>
                        <MenuItem value="2">Rejected</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained" onClick={handleOpenAddCorporate}
                        style={{width:'185px',height: '50px',backgroundColor:'#000000',textTransform:'none',borderRadius:'8px'}}>
                        + Add Corporate
                    </Button>
                </Grid2>
            </Grid2>

            {/* add - edit modal */}
            {open && (
                <div
                style={{
                  position: 'fixed',
                  top: 65,
                  right: 0,
                  height: 'calc(100vh - 65px)',
                  width: '50%',
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                  transition: 'right 0.3s ease-in-out',
                  zIndex: 1000,
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1, overflowY: 'auto', padding: 20
                }}
              >
                    <Box>
                        <div>
                        <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '15px',left: '10px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                        <Typography variant="h6" style={{ marginBottom: '0px', marginTop: '42px',fontSize:'24px', color:'#4E545D' }}>
                            {editable ? 'Edit Corporate' : 'Add Corporate'}
                        </Typography>
                        </div>
                        <div style={{ position: 'relative', padding: '20px 0 40px 0' }}>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', marginTop: '0px' }}>
                                    <Typography variant="h6" style={{ fontSize:'20px', color:'#1A1E25', margin: 0 }}>
                                        Company Details
                                    </Typography>
                                </div>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Corporate Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Corporate Name" fullWidth variant="outlined" type="text" value={corpName} error={nameError}
                                            helperText={nameError ? 'Please enter a valid corporate name' : ''}
                                            required
                                            onChange={(e) => {setCorpName(e.target.value); setNameError(false)}}
                                            InputProps={{
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    {/* <Grid item xs={12} sm={6}>
                                        <Label>Account Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Account Number" fullWidth variant="outlined" type="number" value={accountNumber} error={accounterror}
                                            helperText={accounterror ? 'Please enter a valid account number' : ''}
                                            onChange={(e) => {setAccountNumber(e.target.value); setAccountError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Phone Number<span style={{ color: 'red' }}>*</span></Label>
                                        {/* <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Phone Number" fullWidth variant="outlined" type="number" value={phoneNumber} error={phoneError}
                                            helperText={phoneError ? 'Please enter a valid phone number' : ''}
                                            onChange={(e) => {setPhoneNumber(e.target.value); setPhoneError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        /> */}
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={phoneNumber}
                                            onChange={(value) => {
                                            setPhoneNumber(value);
                                            try {
                                                const parsed = parsePhoneNumber(value);
                                                if (parsed) {
                                                setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                }
                                            } catch (err) {
                                                console.error('Invalid phone number:', err);
                                                setCountryCode('');
                                            }
                                            }}
                                            placeholder="Enter phone number"
                                            style={{
                                            height: '56px',
                                            fontSize: '16px', borderRadius:'12px',
                                            alignItems: 'normal', marginTop:'2%'
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Email<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Email" fullWidth variant="outlined" type="email" value={email} error={emailError} 
                                            disabled={editable}
                                            helperText={emailError ? 'Please enter a valid email address' : ''}
                                            onChange={(e) => {setEmail(e.target.value); setEmailError(false)}}
                                            InputProps={{
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                            <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Alternative Email</Label>
                                            <TextField sx={{ marginTop: '2%' }}
                                                placeholder="Alternative Email (optional)" fullWidth variant="outlined" type="email"
                                                value={alternativeEmail} error={alternativeEmailError}
                                                helperText={alternativeEmailError ? 'Please enter a valid alternative email' : ''}
                                                onChange={(e) => { setAlternativeEmail(e.target.value); setAlternativeEmailError(false); }}
                                                InputProps={{
                                                    style: { height: '56px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF' }
                                                }}
                                            />
                                        </Grid>


                                    {/* <Grid item xs={12} sm={12}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Brand Logo<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Brand Logo" fullWidth variant="outlined" type="file" value={brandLogo} error={brandLogoError}
                                            helperText={brandLogoError ? 'Please enter a valid brand logo' : ''}
                                            onChange={(e) => {setBrandLogo(e.target.value); setBrandLogoError(false)}}
                                            InputProps={{
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid> */}
                                    </Grid>
                                    </Paper>

                                {/* <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '20px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '0px',fontSize:'20px', color:'#1A1E25' }}>
                                Enter Limits
                                </Typography>
                                    <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Monthly Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Monthly Ride Limit" fullWidth variant="outlined" type="number" value={monthlyRideLimit} error={rideLimitError}
                                            helperText={rideLimitError ? 'Please enter a valid monthly ride limit' : ''}
                                            onChange={(e) => {setMonthlyRideLimit(e.target.value); setRideLimitError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Monthly Trans Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Monthly Transaction Limit" fullWidth variant="outlined" type="number" value={monthlyTransactionLimit} error={transactionLimitError}
                                            helperText={transactionLimitError ? 'Please enter a valid monthly transaction limit' : ''}
                                            onChange={(e) => {setMonthlyTransactionLimit(e.target.value); setTransactionLimitError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>
                                    </Grid>
                                    </Paper> */}

                                    <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '20px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                    <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '0px',fontSize:'20px', color:'#1A1E25' }}>
                                     Account Details
                                    </Typography>
                                    <Grid container spacing={2}>

                                    {/* <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Allowed Payment Methods<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={allowedPaymentMethods} fullWidth error={paymentMethodError}
                                            helperText={paymentMethodError ? 'Please select a valid payment method' : ''}
                                            onChange={(e) => {setAllowedPaymentMethods( e.target.value); setPaymentMethodError(false)}}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            
                                                {Object.entries(constants.paymentMethod2).map(([id, label]) => (
                                                    <MenuItem key={id} value={id}>
                                                        {label}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid> */}

                                    {/* <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={corpStatus} fullWidth error={statusError}
                                            helperText={statusError ? 'Please select a valid status' : ''}
                                            onChange={(e) => {setCorpStatus( e.target.value); setStatusError(false)}}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            <MenuItem value="">Status</MenuItem>
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem>
                                        </Select>
                                    </Grid> */}

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Vat Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Vat Number" fullWidth variant="outlined" type="text" value={vatNumber} error={vatError}
                                            helperText={vatError ? 'Please enter a valid vat number' : ''}
                                            onChange={(e) => {setVatNumber(e.target.value); setVatError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>
                                        </Grid>
                                </Paper>
                                                                <Paper elevation={3}
                                    style={{ padding: '30px', maxWidth: '800px', margin: '20px auto',
                                        backgroundColor: '#FFFFFF', borderRadius: '12px' }}>
                                    <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '0px', fontSize: '20px', color: '#1A1E25' }}>
                                        Invoice Details
                                    </Typography>
                                    <Grid container spacing={2}>

                                        <Grid item xs={12} sm={6}>
                                            <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Invoice Date<span style={{ color: 'red' }}>*</span></Label>
                                            <Select sx={{ marginTop: '2%' }}
                                                fullWidth displayEmpty
                                                value={invoiceDate}
                                                error={invoiceDateError}
                                                onChange={(e) => { setInvoiceDate(e.target.value); setInvoiceDateError(false); }}
                                                renderValue={(v) => v === '' ? <span style={{ color: '#9E9E9E' }}>Select day of month</span> : `Day ${v}`}
                                                style={{ height: '56px', fontSize: '16px', backgroundColor: '#FFFFFF' }}
                                                MenuProps={{ PaperProps: { sx: { maxHeight: 280 } } }}
                                            >
                                                {Array.from({ length: 28 }, (_, i) => i + 1).map((d) => (
                                                    <MenuItem key={d} value={d}>{d}</MenuItem>
                                                ))}
                                            </Select>
                                            {invoiceDateError && (
                                                <Typography sx={{ color: '#d32f2f', fontSize: '12px', mt: '4px', ml: '14px' }}>Please select an invoice date</Typography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>Billing Address<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{ marginTop: '2%' }}
                                                placeholder="Street, city, state, postal code, country" fullWidth variant="outlined"
                                                multiline minRows={2}
                                                value={billingAddress} error={billingAddressError}
                                                helperText={billingAddressError ? 'Please enter a billing address' : ''}
                                                onChange={(e) => { setBillingAddress(e.target.value); setBillingAddressError(false); }}
                                                InputProps={{
                                                    style: { fontSize: '16px', padding: '12px 14px', backgroundColor: '#FFFFFF' }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                                {!editable && <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '20px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '0px',fontSize:'20px', color:'#1A1E25' }}>
                                Passwords
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>
                                            Enter Password<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <TextField
                                            sx={{ marginTop: '2%' }}
                                            placeholder="Enter Password"
                                            fullWidth
                                            variant="outlined"
                                            type="password"
                                            value={password}
                                            error={passwordError}
                                            helperText={passwordError ? 'Please enter a valid password' : ''}
                                            onChange={(e) => {
                                                setPassword(e.target.value);
                                                setPasswordError(false);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {
                                                    height: '56px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ fontSize: '16px', fontWeight: '500', color: '#83888E' }}>
                                            Re-Enter Password<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <TextField
                                            sx={{ marginTop: '2%' }}
                                            placeholder="Re-Enter Password"
                                            fullWidth
                                            variant="outlined"
                                            type="password"
                                            value={rePassword}
                                            error={rePasswordError || passwordMismatchError}
                                            helperText={
                                                rePasswordError
                                                    ? 'Please enter a valid re-password'
                                                    : passwordMismatchError
                                                    ? 'Passwords do not match'
                                                    : ''
                                            }
                                            onChange={(e) => {
                                                setRePassword(e.target.value);
                                                setRePasswordError(false);
                                                setPasswordMismatchError(false);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {
                                                    height: '56px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                    </Paper>}
                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleReset}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}><TableSortLabel
                                    active={orderBy === 'id'}
                                    direction={orderBy === 'id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('id')}
                                >Id</TableSortLabel> </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Name
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Name</TableCell> */}
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Monthly Ride Limit</TableCell> */}
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Monthly Transaction Limit</TableCell> */}
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Allowed Payment Methods</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Phone Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Alternative Email</TableCell>
                            
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vat Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Invoice Date</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Billing Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Corporate users</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Invoice</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={16} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {rows.filter((row) => {
                            const isStatusMatch = statusFilter ? statusFilter == row.status : true;
                            return isStatusMatch;
                        })
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            const payment = constants.paymentMethod2[row.allowed_payment_methods]

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '150px' }}>{row.id ? (row.id) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '150px' }}>{row.name ? (row.name) : '--'}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.monthly_ride_limit ? (row.monthly_ride_limit) : '--'}</Typography></TableCell> */}
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.monthly_transaction_limit ? (row.monthly_transaction_limit) : '--'}</Typography></TableCell> */}
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{payment ? (payment) : '--'}</Typography></TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.phone_number ? (row.phone_number) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.email ? (row.email) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.alternative_email ? (row.alternative_email) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.vat_number ? (row.vat_number) : '--'}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {row?.invoice_date ? `Day ${row.invoice_date}` : '--'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.billing_address ? (row.billing_address) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: '#0DBA78', cursor: 'pointer' }} onClick={() => handleViewUsers(row)}>View Users</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: '#0DBA78', cursor: 'pointer',border:'1px solid #0DBA78',padding:'3px 2px',borderRadius:'5px' }} onClick={() => handleInvoiceofCorporateclient(row)}>Invoice</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px', color: row.status === 1 ? '#0DBA78' : row.status==2 ? '#D14545' : 'orange', fontWeight:'500' }}>
                                        {row.status==1 ? 'Approved' : row.status==2 ? 'Rejected' : 'Pending'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'center' }}>
                                            {/* Edit button */}
                                            <Button
                                            variant="contained"
                                            disableRipple
                                            onClick={() => handleOpenEditCorporate(row)}
                                            startIcon={
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                </svg>
                                            }
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78',
                                                border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', width: 186, height: 38,
                                                boxShadow: 'none', fontWeight: 600,
                                                transition: 'all 0.15s ease',
                                                '&:hover': { backgroundColor: '#0DBA78', color: '#fff', boxShadow: '0 2px 8px rgba(13,186,120,0.3)', transform: 'translateY(-1px)' },
                                                '&:active': { backgroundColor: '#0DBA78', color: '#fff', transform: 'translateY(0)' },
                                            }}
                                            >
                                            Edit
                                            </Button>

                                            {/* Approve / Reject segmented control */}
                                            <Box sx={{ display: 'flex', width: 186, border: '1px solid #E0E0E0', borderRadius: '8px', overflow: 'hidden' }}>
                                            {(row.status==0 || row.status==2) && 
                                                <Button
                                                    variant="text"
                                                    onClick={() => handleApproveReject(1, row.id)}
                                                    sx={{
                                                    flex: 1, height: 38, textTransform: 'none', fontWeight: 600, borderRadius: 0, boxShadow: 'none',
                                                    backgroundColor: row.status === 1 ? '#0DBA78' : 'transparent',
                                                    color: row.status === 1 ? '#fff' : '#9E9E9E',
                                                    transition: 'all 0.15s ease',
                                                    '&:hover': { backgroundColor: row.status === 1 ? '#0BA96C' : '#F4F4F4' },
                                                    }}
                                                >
                                                    Approve
                                                </Button>
                                            }

                                            <Box sx={{ width: '1px', backgroundColor: '#E0E0E0' }} />
                                            {(row.status==1 || row.status==0) && 
                                                <Button
                                                    variant="text"
                                                    onClick={() => handleApproveReject(2, row.id)}
                                                    sx={{
                                                    flex: 1, height: 38, textTransform: 'none', fontWeight: 600, borderRadius: 0, boxShadow: 'none',
                                                    backgroundColor: row.status === 2 ? '#D14545' : 'transparent',
                                                    color: row.status === 2 ? '#fff' : '#9E9E9E',
                                                    transition: 'all 0.15s ease',
                                                    '&:hover': { backgroundColor: row.status === 2 ? '#C13C3C' : '#FBEEEE' },
                                                    }}
                                                >
                                                    Reject
                                                </Button>
                                            }

                                            </Box>
                                            
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            <Modal open={invoiceModalOpen} onClose={handleCloseInvoiceModal}>
    <Box sx={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: { xs: '95%', md: '90%' }, maxWidth: 1200, height: '88vh',
        bgcolor: '#FFFFFF', borderRadius: '12px', boxShadow: 24, outline: 'none',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, borderBottom: '1px solid #E5E7EB' }}>
            <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#1A1E25' }}>Invoices</Typography>
                <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>{invoiceCorpName}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {selectedInvoice && (
                    <Button
                        onClick={() => handleDownloadInvoice(selectedInvoice)}
                        disabled={downloadingInvoice}
                        sx={{
                            textTransform: 'none', borderRadius: '8px', height: 40, px: 2.5,
                            backgroundColor: '#0065FF', color: '#fff',
                            '&:hover': { backgroundColor: '#0856d3' },
                            '&.Mui-disabled': { backgroundColor: '#E5E7EB', color: '#9CA3AF' },
                        }}
                    >
                        {downloadingInvoice ? 'Downloading…' : 'Download PDF'}
                    </Button>
                )}
                <IconButton onClick={handleCloseInvoiceModal} sx={{ color: '#6B7280' }}>
                    <CloseIcon />
                </IconButton>
            </Box>
        </Box>

        {/* Body */}
        {invoiceData.length === 0 ? (
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: '#9FA3A7' }}>No invoices found for this corporate.</Typography>
            </Box>
        ) : (
            <Box sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
                {/* Invoice list */}
                <Box sx={{ width: 300, borderRight: '1px solid #E5E7EB', overflowY: 'auto', p: 1.5 }}>
                    {invoiceData.map((inv) => {
                        const active = selectedInvoice?.id === inv.id;
                        return (
                            <Box
                                key={inv.id}
                                onClick={() => setSelectedInvoice(inv)}
                                sx={{
                                    p: 1.5, mb: 1, borderRadius: '10px', cursor: 'pointer',
                                    border: `1px solid ${active ? '#0065FF' : '#E6F0FF'}`,
                                    backgroundColor: active ? '#F3F8FF' : '#FFFFFF',
                                    '&:hover': { backgroundColor: '#F9FBFF' },
                                }}
                            >
                                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065FF' }}>
                                    {inv.billing_month}
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 0.25 }}>
                                    {inv.invoice_number}
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.75 }}>
                                    <Typography sx={{ fontSize: '12px', color: '#4E545D' }}>
                                        {inv.total_rides} rides
                                    </Typography>
                                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1A1E25' }}>
                                        {Number(inv.total_amount).toFixed(2)}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>

                {/* PDF preview */}
<Box sx={{ flex: 1, backgroundColor: '#F3F4F6' }}>
    {pdfLoading ? (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography sx={{ color: '#9FA3A7' }}>Loading invoice…</Typography>
        </Box>
    ) : pdfBlobUrl ? (
        <iframe
            key={selectedInvoice?.id}
            src={`${pdfBlobUrl}#toolbar=0`}
            title={selectedInvoice?.invoice_number}
            style={{ width: '100%', height: '100%', border: 'none' }}
        />
    ) : pdfError ? (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'center', justifyContent: 'center' }}>
            <Typography sx={{ color: '#9FA3A7' }}>Preview unavailable.</Typography>
            <Button
                onClick={() => window.open(selectedInvoice.invoice_url, '_blank', 'noopener')}
                sx={{ textTransform: 'none', borderRadius: '8px', border: '1px solid #0065FF', color: '#0065FF' }}
            >
                Open in new tab
            </Button>
        </Box>
    ) : (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography sx={{ color: '#9FA3A7' }}>Select an invoice to preview</Typography>
        </Box>
    )}
</Box>
            </Box>
        )}
    </Box>
</Modal>
        </div>
        </>
    )
}

export default Corporate;